//*****************************Dashboard *********************************** */
export const DASHBORD_1 = 171

// ***************************** Utility **************************************//

export const SEARCH_BOX2 = "/SearchBoxSecond"
export const SEARCH_BOX3 = "/SerachBox3"

// *************************** POS Administration *******************************//
export const POS_USER = 281
export const POS_USER_lIST = 282

export const POS_LOG = 309

export const TRANSACTION_LOG = 235

export const CUSTOMER_ITEM_ASSIN = 367

export const FRANCHISE_LICENSE = 392


export const DAILY_DISPATCH_REPORT = 339

export const SERVICE_SETTINGS = 374

export const VENDOR_PRODUCTION = 386

export const VENDOR_PRODUCTION_LIST = 387

export const POS_SALE_SUMMARY_REPORT = 340

export const MANAGER_SUMMARY_REPORT = 347

export const ITEM_CONSUMPTION_REPORT = 353

export const BATCH_TRACEABILITY = 361

export const PARTY_WISE_ITEM_SALE_REPORT = 363

export const ANNUAL_ITEM_SALE_REPORT = 381

export const POS_DASHBOARD_DETAILS = 375

export const SUPER_ADMIN_DASHBOARD = 393


export const BILL_DELETE_SUMMARY_REPORT = 346

export const SCHEME_MASTER_lIST = 351

export const SCHEME_MASTER = 350

export const STOCK_ADJUSTMENT_REPORT = 359


export const SWIGGY_ZOMATO_CLAIM = 362


export const ORDER_APPROVAL = 394





// *************************** Administration *******************************//

export const MODULE = 5
export const MODULE_lIST = 6

export const COMPANY = 1
export const COMPANY_lIST = 2

export const USER = 13
export const USER_lIST = 14

export const ROLE = 19
export const ROLE_lIST = 20

export const ROLEACCESS = 9
export const ROLEACCESS_lIST = 10
export const COPY_ROLEACCESS = "/RoleAccessCopyFunctionality"

// *************************** Master Module **********************************//
export const MINI_ITEM_MASTER = 354
export const MAPPING_MASTER = 381

export const CHALLAN_MASTER_LIST = 383
export const CHALLAN_MASTER = 382

export const CSS_BULK_INVOICE = 384

export const NOC_DOCUMENT_UPLOAD = 366
export const NOC_LIST_PAGE = 370

export const ITEM = 25
export const ITEM_lIST = 26

export const GST = 48
export const GST_LIST = 49

export const COMPANYGROUP = 3
export const COMPANYGROUP_lIST = 4

export const EMPLOYEE = 11
export const EMPLOYEE_lIST = 12

export const EMPLOYEETYPE = 46
export const EMPLOYEETYPE_lIST = 47

export const CATEGORYTYPE = 21
export const CATEGORYTYPE_lIST = 22

export const DRIVER = 33
export const DRIVER_lIST = 34

export const PARTY = 57
export const PARTY_lIST = 18

export const RETAILER_MASTER = 195
export const RETAILER_LIST = 196

export const NON_RETAILER_PARTY = 237
export const NON_RETAILER_PARTY_lIST = 238

export const PARTY_SELF_EDIT = 204

export const PARTYTYPE = 31
export const PARTYTYPE_lIST = 32

export const CATEGORY = 23
export const CATEGORY_lIST = 24

export const VEHICLE = 29
export const VEHICLE_lIST = 30

export const GROUPTYPE = 44
export const GROUPTYPE_lIST = 45

export const GROUP = 50
export const GROUP_lIST = 51

export const PRICE = 35
export const PRICE_lIST = 37

export const MRP = 38
export const MRP_lIST = 39

export const MARGIN = 40
export const MARGIN_lIST = 41

export const PAGE = 7
export const PAGE_lIST = 8

export const TERMS_AND_CONDITION = 42
export const TERMS_AND_CONDITION_LIST = 43

export const PARTY_SUB_PARTY = 52
export const PARTY_SUB_PARTY_lIST = 58

export const PARTYITEM = 36

export const CHANNEL_ITEM = 228

export const SUBGROUP = 61
export const SUBGROUP_LIST = 63

export const GENERAL = 119
export const GENERAL_LIST = 120

export const ROUTES = 149
export const ROUTES_LIST = 150

export const SALESMAN = 151
export const SALESMAN_LIST = 152

export const IMPORT_EXCEL_FIELD_MAP = 157

export const IMPORT_CREDIT_NOTE_EXCEL_FIELD_MAP = 274

export const IMPORT_MASTER_MAP = 194

export const INVOICE_EXCEL_UPLOAD = 184
export const RETAILER_EXCEL_UPLOAD = 184

export const IMPORT_FIELD_ADD = 188
export const IMPORT_FIELD_ADD_LIST = 189


export const TARGET_UPLOAD = 270
export const TARGET_UPLOAD_LIST = 271

export const CREDIT_NOTE_UPLOAD = 276

export const IMPORT_EXCEL_PARTY_MAP = 194

export const ROUTE_UPDATE = 159
export const PARTY_MASTER_BULK_UPDATE = 161

export const MANAGEMENT_PARTIES = 172

export const BANK = 175
export const BANK_LIST = 176

export const CITY = 200
export const CITY_LIST = 202

export const INVOICE_CONFIGURATION = 206

export const MANAGEMENT_SETTINGS = 385

export const BANK_ASSIGN = 182

export const PRODUCT_MARGIN_REPORT = 198

export const DISCOUNT_MASTER = 212
export const DISCOUNT_LIST = 213

export const CLUSTER_MASTER = 252
export const CLUSTER_lIST = 253

export const SUB_CLUSTER_MASTER = 254
export const SUB_CLUSTER_lIST = 255

export const RETAILER_MASTER_1 = 325
export const RETAILER_MASTER_LIST_1 = 326






export const CENTRAL_SERVICE_ITEM = 250
export const CENTRAL_SERVICE_ITEM_LIST = 251

export const SERVICE_ITEM_ASSIGN = 256

export const PARTY_DETAILS = 260

export const ITEM_MASTER_BULK_UPDATE = 261

export const ITEM_SUPPLIER_ASSIGN = 292

export const PARTY_EMPLOYEE_DETAILS = 275

export const RATE_MASTER = 277
export const RATE_LIST = 278

export const FRANCHISE_CUSTOMER_MASTER = 307

export const FRANCHISE_CUSTOMER_LIST = 308

export const COUNTRY_MASTER = 310
export const COUNTRY_LIST = 311

export const VOUCHER = 320
export const VOUCHER_LIST = 321

export const MOBILE_RETAILER_SEND = 249

//******************************* Purchase Module ************************************//
export const ORDER_1 = 53
export const ORDER_LIST_1 = 54

export const ORDER_2 = 117
export const ORDER_LIST_2 = 118

export const IB_ORDER = 126
export const IB_ORDER_PO_LIST = 127
export const IB_ORDER_SO_LIST = 147

export const IB_SALES_ORDER = 284


export const ORDER_QUATATION = 329
export const ORDER_QUATATION_LIST = 330



export const ORDER_4 = 144
export const ORDER_LIST_4 = 143

export const APP_ORDER_LIST = 267

export const BIllOf_MATERIALS = 69
export const BIllOf_MATERIALS_LIST = 70

export const WORK_ORDER = 72
export const WORK_ORDER_LIST = 73

export const BULK_WORK_ORDER = 285

export const MATERIAL_ISSUE = 75
export const MATERIAL_ISSUE_LIST = 76
export const MATERIAL_ISSUE_STP = 125

export const PRODUCTION_MASTER = 77
export const PRODUCTION_LIST = 78
export const PRODUCTION_STP = 123

export const PRODUCTION_REISSUE = 140
export const PRODUCTION_REISSUE_LIST = 141
export const PRODUCTION_REISSUE_STP = 142

export const INVOICE_1 = 121
export const INVOICE_LIST_1 = 122

export const FRANCHAISE_INVOICE = 317

export const POS_INVOICE_LIST = 288

export const BULK_WORK_ORDER_LIST = 289

export const FRENCHIESE_SALE_REPORT = 290

export const BULK_INVOICE = 265

//******************************* Inventory Module ************************************//

export const GRN_ADD_1 = 55
export const IB_GRN_LIST = 56
export const GRN_STP_1 = 124

export const GRN_ADD_3 = 165
export const GRN_LIST_3 = 166
export const GRN_STP_3 = 164


export const ACCOUNTING_GRN = 331
export const ACCOUNTING_GRN_LIST = 332
export const GRN_FOR_ACCOUNTING_GRN = 335

export const IB_GRN = 336




export const STOCK_ENTRY = 205
export const STOCK_ENTRY_LIST = 293

export const STOCK_ADJUSTMENT = 236
export const STOCK_ADJUSTMENT_LIST = 391

export const STOCK_ADJUSTMENT_MODE_2 = 239

//******************************* Inter Branch ************************************//

export const INWARD = 128
export const INWARD_LIST = 129
export const IB_INWARD_STP = 133

export const IB_INVOICE = 130
export const IB_INVOICE_LIST = 131
export const IB_INVOICE_FOR_GRN = 146
export const IB_INVOICE_STP = 132

export const VDC_INVOICE = 333
export const VDC_INVOICE_LIST = 334

export const RATE_ADJUSTMENT = 337

export const WASTAGE_ENTRY_MASTER = 378
export const WASTAGE_LIST = 379

// export const IB_INVOICE_STP = 132

//******************************* Sales ************************************//

export const PURCHASE_RETURN = 209
export const PURCHASE_RETURN_LIST = 210

export const LOADING_SHEET = 155
export const LOADING_SHEET_LIST = 156

export const LOADING_SHEET_LIST_UPDATE = 179

export const SALES_RETURN = 186
export const SALES_RETURN_LIST = 187

export const PURCHASE_RETURN_MODE_3 = 211

//**************************** Accounting ***********************************//

// ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||

export const CREDIT_NOTE = 190
export const CREDIT_LIST = 191

export const DEBIT_NOTE = 192
export const DEBIT_LIST = 193

export const GOODS_CREDIT_LIST = 229
export const GOODS_CREDIT_NOTE = 228

export const GOODS_DEBIT_LIST = 231
export const GOODS_DEBIT_NOTE = 230

export const CREDIT_NOTE_1 = 258
export const CREDIT_NOTE_LIST_1 = 259
// ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||


export const RECEIPTS = 173
export const RECEIPTS_LIST = 174

export const RECEIPTS_LIST_2 = 180

export const BULK_RECIPT = 181

export const PAYMENT_ENTRY = 177
export const PAYMENT_ENTRY_LIST = 178

export const CLAIM_TRACKING_ENTRY = 240
export const CLAIM_TRACKING_ENTRY_LIST = 241

export const SAP_LEDGER = 197

//**************************** Reports ***********************************//

export const RATE_LIST_REPORT = 371

export const LOYALTY_CLAIM_REPORT = 372

export const BILL_PROCESSING_REPORT = 369

export const ORDER_SUMMARY_REPORT = 203

export const GENERIC_SALE_REPORT = 214

export const RETAILER_DATA_REPORT = 215

export const CLAIM_SUMMARY_REPORT = 217

export const DAMAGE_STOCK_REPORT = 220

export const DELETE_INVOICE_DATA_EXPORT = 221

export const RETURN_REPORT = 223

export const PURCHASE_GST_REPORT = 219

export const INVOICE_DATA_EXPORT = 218

export const PURCHASE_DATA_EXPORT = 234

export const ITEM_SALE_REPORT = 224

export const CLAIM_SUMMARY_MASTER = 226

export const CLAIM_SUMMARY_lIST = 227

export const STOCK_REPORT = 208

export const STOCK_REPORT_1 = 216

export const DEBIT_DATA_EXPORT = 243

export const CREDIT_DATA_EXPORT = 244

export const PERIODIC_GRN_REPORT_ = 338


export const RECEIPT_DATA_EXPORT = 245


export const PARTY_OUTSTANDING_REPORT = 246


export const RETAILER_APPROVAL = 247


export const MAN_POWER_REPORT = 248



export const PARTY_LEDGER = 207



export const CLAIM_TRACKING_REPORT = 257


export const TCS_AMOUNT_REPORT = 263


export const CX_DD_DIFFERENCE_REPORT = 264


export const CSS_ITEM_SALE_REPORT = 344


export const ORDER_ITEM_SUPPLIER_REPORT = 301

export const PERIOD_WISE_INVOICE_REPORT = 364

// ***************** Sweet POS *******************



export const POS_SERVICE_SETTING_LIST = 356

export const POS_SERVICE_SETTING = 355



export const PHONE_PAY_SETTING_LIST = 358

export const PHONE_PAY_SETTING = 357


export const POS_ROLE_ACCESS = 266

export const SYSTEM_SETTING = 268

export const SYSTEM_SETTING_LIST = 269

export const TARGET_VS_ACHIEVEMENT = 273

export const CASHIER_SUMMARY_REPORT = 287

export const SWEET_POS_RATE_MASTER = 295

export const SWEET_POS_MACHINE_MASTER = 304

export const SWEET_POS_MACHINE_LIST = 315

export const STOCK_OUT_REPORT = 306

export const FRANCHAISE_SALE_WITH_BILL_COUNT = 316

export const FRANCHISE_PARTY_MASTER = 352

export const BILL_BOOKING_REPORT = 318

export const GRN_PENDING_REPORT = 322

export const DATA_EXPORT_TO_SAP = 323

export const GRN_DISCREPANCY_REPORT = 324


export const DEMAND_VS_SUPPLY = 319


export const CODE_REDEMPTION_REPORT = 327


export const VOUCHER_REDEMPTION_CLAIM = 328


export const SCHEME_TYPE_LIST = 349

export const SCHEME_TYPE = 348

export const GENERIC_MESSAGE_MASTER = 376
export const GENERIC_MESSAGE_LIST = 377

export const INDIA_PORTAL_REGISTRATION = 388

export const Frenchises_Dashboard = 389

export const MBQ_AND_MVQ = 390

export const ERP_URL_L = 395

export const ERP_URL_M = 396

export const CASH_BOOK_HEAD = 3889

export const CASH_BOOK_HEAD_LIST = 3890




export const CASH_BOOK_ENTRY_LIST = 3895

export const CASH_BOOK_ENTRY = 3891

export const CASH_BOOK_ENTRY_REPORT = 3896